import React, { useState, useEffect } from 'react';
import './StudentForm.css';
import eliteLogo from './elite-logo.png';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


//initialize usestate


function StudentForm() {
  const [locations, setLocations] = useState([]);
  const [studentData, setStudentData] = useState({
    id: '',
    first_name: '',
    last_name: '',
    dob: '',
    grade_level: '',
    status: 'Active',
    location: '',
    guardian1_first_name: '',
    guardian1_last_name: '',
    guardian1_address: '',
    guardian1_phone: '',
    guardian1_email: '',
    guardian2_first_name: '',
    guardian2_last_name: '',
    guardian2_address: '',
    guardian2_phone: ''
  });

  const [showGuardian2, setShowGuardian2] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');


//fetch practice locations from the backend


useEffect(() => { 
  fetch(`${process.env.REACT_APP_API_BASE_URL}/locations`)
      .then((res) => res.json())
      .then((data) => {
          console.log("📌 Updated locations:", data); // ✅ Debugging output
          setLocations(data);
      })
      .catch(err => console.error('❌ Error fetching locations:', err));
}, []);

// ✅ New: Log `location_id` when it updates
useEffect(() => {
  console.log("📌 Selected location_id:", studentData.location_id);
}, [studentData.location_id]);



//handle input change update the student data state


  const handleInputChange = (e, field) => {
    setStudentData((prev) => ({
      ...prev,
      [field]: e.target.value || '',
    }));
  };

  const handleAddGuardian = () => {
    setShowGuardian2(true);
  };

  const handleRemoveGuardian = () => {
    setShowGuardian2(false);  // ✅ Ensure button reappears
    setStudentData((prev) => ({
      ...prev,
      guardian2_first_name: '',
      guardian2_last_name: '',
      guardian2_address: '',
      guardian2_phone: '',
      guardian2_email: ''  // ✅ Ensure email field is cleared too
    }));
  };
  

  const handleCopyAddress = () => {
    setStudentData((prev) => ({
      ...prev,
      guardian2_address: prev.guardian1_address,
    }));
  };


// Fetch by Student ID

const fetchStudentById = async (id) => {
  if (!id) return;
  try {
      const response = await fetch(`${API_BASE_URL}/students/${id}`);

      if (!response.ok) {
          console.warn("❌ No student found with this ID. Preparing to create a new student.");
          setMessage("⚠️ No student found. Enter details to create a new student.");
          
          // ✅ Reset form but keep the ID entered & indicate it's a new student
          setStudentData({
              id,
              first_name: '',
              last_name: '',
              dob: '',
              grade_level: '',
              status: 'Active',
              location_id: '',
              guardian1_first_name: '',
              guardian1_last_name: '',
              guardian1_phone: '',
              guardian1_address: '',
              guardian1_email: '',
              guardian2_first_name: '',
              guardian2_last_name: '',
              guardian2_phone: '',
              guardian2_address: '',
              guardian2_email: '',
              isNewStudent: true,
          });

          setShowGuardian2(false); // ✅ Hide secondary guardian section
          return;
      }

      const data = await response.json();
      console.log("📥 Retrieved Student Data:", JSON.stringify(data, null, 2));

      const formattedDob = data.dob ? data.dob.split('T')[0] : '';

      setStudentData({
          ...data,
          dob: formattedDob,
          location_id: data.location_id || '',
          guardian1_first_name: data.guardian1?.first_name || '',
          guardian1_last_name: data.guardian1?.last_name || '',
          guardian1_phone: data.guardian1?.phone || '',
          guardian1_address: data.guardian1?.address || '',
          guardian1_email: data.guardian1?.email || '',
          guardian2_first_name: data.guardian2?.first_name || '',
          guardian2_last_name: data.guardian2?.last_name || '',
          guardian2_phone: data.guardian2?.phone || '',
          guardian2_address: data.guardian2?.address || '',
          guardian2_email: data.guardian2?.email || '',
          isNewStudent: false,
      });

      // ✅ Automatically show Guardian 2 section if they exist
      const hasGuardian2 = !!data.guardian2?.first_name;
      setShowGuardian2(hasGuardian2); // ✅ Set visibility for Guardian 2
      console.log("📌 Guardian 2 exists:", hasGuardian2);

      setMessage("✅ Student data retrieved.");
  } catch (error) {
      console.error("❌ Error fetching student:", error);
      setMessage("❌ Error: Could not retrieve student data.");
  }
};


//fetch by phone number

const fetchStudentByPhoneNumber = async (phoneNumber) => {
  if (!phoneNumber) return;
  try {
      const response = await fetch(`${API_BASE_URL}/students/phone/${phoneNumber}`);
      if (!response.ok) {
          setMessage('❌ Error: No student found with this phone number.');
          return;
      }
      const data = await response.json();
      
      console.log("📥 Retrieved Student Data by Phone:", JSON.stringify(data, null, 2)); // ✅ Debugging log

      // ✅ Convert `dob` to YYYY-MM-DD format (removes time part)
      const formattedDob = data.dob ? data.dob.split('T')[0] : '';

      // ✅ Ensure all student data fields are updated
      setStudentData((prev) => ({
          ...prev,
          ...data, // Merge retrieved data
          dob: formattedDob,  // ✅ Correctly formatted date for input field
          location_id: data.location_id || '', // Ensure correct location ID
          guardian1_first_name: data.guardian1?.first_name || '',
          guardian1_last_name: data.guardian1?.last_name || '',
          guardian1_phone: data.guardian1?.phone || '',
          guardian1_address: data.guardian1?.address || '',
          guardian1_email: data.guardian1?.email || '',
          guardian2_first_name: data.guardian2?.first_name || '',
          guardian2_last_name: data.guardian2?.last_name || '',
          guardian2_phone: data.guardian2?.phone || '',
          guardian2_address: data.guardian2?.address || '',
          guardian2_email: data.guardian2?.email || ''
      }));

      // ✅ Show Guardian 2 section if guardian2 exists
      setShowGuardian2(data.guardian2 && (data.guardian2.first_name || data.guardian2.phone));
      setMessage('✅ Student data retrieved.');
  } catch (error) {
      console.error('❌ Error fetching student by phone:', error);
      setMessage('❌ Error: Could not retrieve student data.');
  }
};


//saves, updates, or fetches student data in backend CRUD BRUH


const handleSubmit = async (e) => {
  const confirmSubmit = window.confirm("Are you sure you want to submit?");
if (!confirmSubmit) {
    setIsSubmitting(false);
    return;
}

  e.preventDefault();
  setIsSubmitting(true);
  setMessage('');

  console.log("📤 Final Form Submission Data:", JSON.stringify(studentData, null, 2));

  if (!studentData.id || !studentData.first_name || !studentData.last_name || !studentData.dob || !studentData.grade_level || !studentData.guardian1_first_name || !studentData.guardian1_phone) {
      setMessage('⚠️ Error: All required fields must be filled. Please ensure Student ID, Name, DOB, Grade Level, and Primary Guardian information are complete.');
      setIsSubmitting(false);
      return;
  }

  const { location, isNewStudent, ...filteredData } = studentData;
  const requestData = { ...filteredData, location_id: studentData.location_id };

  requestData.guardian1 = {
      first_name: studentData.guardian1_first_name,
      last_name: studentData.guardian1_last_name || '',
      address: studentData.guardian1_address || '',
      phone: studentData.guardian1_phone,
      email: studentData.guardian1_email || ''
  };

  if (showGuardian2) {
      requestData.guardian2 = {
          first_name: studentData.guardian2_first_name || '',
          last_name: studentData.guardian2_last_name || '',
          address: studentData.guardian2_address || '',
          phone: studentData.guardian2_phone || '',
          email: studentData.guardian2_email || ''
      };
  } else {
      requestData.guardian2 = null;
  }

  try {
      const method = isNewStudent ? 'POST' : 'PUT';
      const endpoint = isNewStudent ? `${API_BASE_URL}/students` : `${API_BASE_URL}/students/${studentData.id}`;

      console.log("🔍 Submitting to:", endpoint);
      console.log("📤 Request Data:", JSON.stringify(requestData, null, 2));

      const response = await fetch(endpoint, {
          method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData)
      });

      const result = await response.json();
      if (response.ok) {
          setMessage(isNewStudent ? '✅ Student successfully added!' : '✅ Student successfully updated!');
      } else {
          setMessage(`❌ Failed to save student: ${result.message || 'Please try again.'}`);
      }
  } catch (error) {
      console.error('Error submitting student:', error);
      setMessage(`❌ Error submitting student data: ${error.message}`);
  } finally {
      setIsSubmitting(false);
  }
};



//clear button

const handleClearForm = () => {
  setStudentData({
      id: '',
      first_name: '',
      last_name: '',
      dob: '',
      grade_level: '',
      status: 'Active',
      location: '',
      guardian1_first_name: '',
      guardian1_last_name: '',
      guardian1_address: '',
      guardian1_phone: '',
      guardian1_email: '',
      guardian2_first_name: '',
      guardian2_last_name: '',
      guardian2_address: '',
      guardian2_phone: ''
  });
  setShowGuardian2(false);
  setMessage('');
};


//delete student data

const handleDelete = async () => {
  if (!studentData.id) return;

  const confirmDelete = window.confirm(`Are you sure you want to delete student ID: ${studentData.id}? This action is permanent.`);

  if (!confirmDelete) return;

  try {
      const response = await fetch(`${API_BASE_URL}/students/${studentData.id}`, {
          method: 'DELETE',
      });

      const result = await response.json();

      if (response.ok) {
          setMessage("🗑️ " + result.message);
          handleClearForm(); // Reset the form
      } else {
          setMessage(`❌ Delete failed: ${result.message}`);
      }
  } catch (error) {
      console.error("Error deleting student:", error);
      setMessage(`❌ Error deleting student: ${error.message}`);
  }
};


<button
  type="button"
  className="delete-btn"
  onClick={handleDelete}
  disabled={!studentData.id || isSubmitting}
>
  Delete Student
</button>


// return the form structure with the student data and the form fields


  return (
    <div className="container">
      <div className={`student-form-container ${studentData.status === 'Active' ? 'active' : 'inactive'}`}>
        <h2 className="title">ELITE BASKETBALL ACADEMY REGISTRATION</h2>
        <div className="id-status-row">
        <input
    type="text"
    className="id-input"
    value={`EBA${studentData.id}`}
    onChange={(e) => {
        const numericPart = e.target.value.replace(/\D/g, '');
        setStudentData((prev) => ({ ...prev, id: numericPart }));
        fetchStudentById(numericPart); // Call the function when ID is entered
    }}
    placeholder="EBA12345"
/>



          
{/* Location Dropdown field */}
<div className="location-container" style={{ width: "100px", height: "40px" }}>
  <select
    id="location"
    className="location-dropdown"
    style={{ width: "100%", height: "100%", fontSize: "14px", textAlign: "center" }}
    value={studentData.location_id || ""}  // ✅ Store `location_id`
    onChange={(e) => {
        const selectedId = Number(e.target.value);
        console.log("📌 Dropdown selected location_id:", selectedId); // ✅ Log selected ID
        setStudentData({ ...studentData, location_id: selectedId }); // ✅ Store `location_id`
    }}
  >
    <option value="">Select Location</option> {/* Default option */}
    {locations.map((loc) => (
      <option key={loc.id} value={loc.id}>{loc.name}</option>  // ✅ Send `id`, display `name`
    ))}
  </select>
</div>




          <select className="status-dropdown" value={studentData.status} onChange={(e) => handleInputChange(e, 'status')}>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <div className="student-info">
          <input type="text" placeholder="First Name" value={studentData.first_name} onChange={(e) => handleInputChange(e, 'first_name')} />
          <input type="text" placeholder="Last Name" value={studentData.last_name} onChange={(e) => handleInputChange(e, 'last_name')} />
          <input type="date" placeholder="Date of Birth" value={studentData.dob} onChange={(e) => handleInputChange(e, 'dob')} />
          <input type="text" placeholder="Grade Level" value={studentData.grade_level} onChange={(e) => handleInputChange(e, 'grade_level')} />
        </div>

        <div className="guardian-section">
          <h3>Primary Guardian</h3>
          <input type="text" placeholder="First Name" value={studentData.guardian1_first_name} onChange={(e) => handleInputChange(e, 'guardian1_first_name')} />
          <input type="text" placeholder="Last Name" value={studentData.guardian1_last_name} onChange={(e) => handleInputChange(e, 'guardian1_last_name')} />
          <input type="text" placeholder="Address" value={studentData.guardian1_address} onChange={(e) => handleInputChange(e, 'guardian1_address')} />
          <input
  type="text"
  placeholder="Phone"
  value={studentData.guardian1_phone}
  onChange={(e) => {
      const phoneNumber = e.target.value;
      setStudentData((prev) => ({ ...prev, guardian1_phone: phoneNumber }));
      fetchStudentByPhoneNumber(phoneNumber); // ✅ Fetch student when phone number is entered
  }}
/>

          <input type="text" placeholder="Email" value={studentData.guardian1_email} onChange={(e) => handleInputChange(e, 'guardian1_email')} />
        </div>

       

        {!showGuardian2 && (
  <button type="button" className="add-guardian-btn" onClick={handleAddGuardian}>
    Add Secondary Guardian
  </button>
)}


        {showGuardian2 && (
  <div className="guardian-section">
    <h3>Secondary Guardian</h3>
    <input type="text" placeholder="First Name" value={studentData.guardian2_first_name} onChange={(e) => handleInputChange(e, 'guardian2_first_name')} />
    <input type="text" placeholder="Last Name" value={studentData.guardian2_last_name} onChange={(e) => handleInputChange(e, 'guardian2_last_name')} />
    <input type="text" placeholder="Address" value={studentData.guardian2_address} onChange={(e) => handleInputChange(e, 'guardian2_address')} />
    <button type="button" className="copy-address-btn" onClick={handleCopyAddress}>Same as Primary Guardian</button>
    <input type="text" placeholder="Phone" value={studentData.guardian2_phone} onChange={(e) => handleInputChange(e, 'guardian2_phone')} />
    <input type="text" placeholder="Email" value={studentData.guardian2_email} onChange={(e) => handleInputChange(e, 'guardian2_email')} />  {/* ✅ New Email Field */}
    <button type="button" className="remove-guardian-btn" onClick={handleRemoveGuardian}>Remove Secondary Guardian</button>
  </div>
)}


<button type="button" className="submit-btn" onClick={handleSubmit} disabled={isSubmitting}>
  {isSubmitting ? 'Submitting...' : 'Submit'}
</button>

<button
  type="button"
  className="delete-btn"
  onClick={handleDelete}
  disabled={!studentData.id || isSubmitting}
>
  Delete Student
</button>

{message && <p className="message">{message}</p>}

<button type="button" onClick={handleClearForm} className="clear-btn">
  Clear Form
</button>


      </div>
      <img src={eliteLogo} alt="Elite Basketball Academy" className="small-logo" />
    </div>
  );
}

export default StudentForm;
